import { createSelector } from 'reselect';

import { TRANSFER_STATES } from '../constant/transfer-states';
import { NormalizedTransfer } from '../types/transfers';
import { State as SpacesState } from '@wetransfer/transfer/spaces-bundle/store/types';
import { allowedSizeSelector } from '@wetransfer/transfer/store/selector/transfers';
import { State } from '@wetransfer/transfer/store/types';

const transferSelector = (state: State | SpacesState) => state.transfer;

const transfersSelector = (state: State) => state.transfers;

export const transferUploadInProgress = createSelector(
  transferSelector,
  (transfer) => {
    return [TRANSFER_STATES.STARTED, TRANSFER_STATES.PAUSED].includes(
      transfer.state
    );
  }
);

export const getCurrentSize = createSelector(transferSelector, (transfer) => {
  if (!transfer) {
    return 0;
  }

  const items = transfer.items || transfer.files || [];

  return items.reduce((currentSize, { size }) => {
    const fileSize = Number(size);

    if (!isNaN(fileSize)) {
      return currentSize + fileSize;
    }

    return currentSize;
  }, 0);
});

export const getRemainingSize = createSelector(
  allowedSizeSelector,
  getCurrentSize,
  (allowedSize, currentSize) => {
    return allowedSize - currentSize;
  }
);

export const getForwardedTransferId = createSelector(
  transferSelector,
  (transfer) => transfer.parent_id
);

export const getIsForwardedTransfer = createSelector(
  [transferSelector],
  (transfer) => {
    return Boolean(transfer.parent_id);
  }
);

export const getForwardedTransfer = createSelector(
  getIsForwardedTransfer,
  transferSelector,
  (isForwarded, transfer): NormalizedTransfer | undefined => {
    if (isForwarded) return transfer as NormalizedTransfer;
  }
);

export const getCurrentStorage = createSelector(
  transfersSelector,
  (transfers): number => {
    return transfers.list.reduce((totalSize, { size }) => totalSize + size, 0);
  }
);
